<!--

 -->

<template>
  <oxd-input-field
    type="select"
    :label="$t('claim.event')"
    :options="options"
    required
  />
</template>

<script>
import {ref, onBeforeMount} from 'vue';
import {APIService} from '@ohrm/core/util/services/api.service';
export default {
  name: 'ClaimEventDropdown',
  setup() {
    const options = ref([]);
    const http = new APIService(
      window.appGlobal.baseUrl,
      'api/v2/claim/expenses/types',
    );
    onBeforeMount(() => {
      http.getAll({limit: 0, status: true}).then(({data}) => {
        options.value = data.data.map((item) => {
          return {
            id: item.id,
            label: item.name,
          };
        });
      });
    });
    return {
      options,
    };
  },
};
</script>
